var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRotate90Ccw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4350_15046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34 6.41001L0.860001 12.9L7.35 19.38L13.84 12.9L7.34 6.41001ZM3.69 12.9L7.35 9.24001L11 12.9L7.34 16.56L3.69 12.9ZM19.36 6.64001C17.61 4.88001 15.3 4.00001 13 4.00001V0.76001L8.76 5.00001L13 9.24001V6.00001C14.79 6.00001 16.58 6.68001 17.95 8.05001C20.68 10.78 20.68 15.22 17.95 17.95C16.58 19.32 14.79 20 13 20C12.03 20 11.06 19.79 10.16 19.39L8.67 20.88C10.02 21.62 11.51 22 13 22C15.3 22 17.61 21.12 19.36 19.36C22.88 15.85 22.88 10.15 19.36 6.64001Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4350_15046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRotate90Ccw);
export default __webpack_public_path__ + "static/media/ico-rotate-90-ccw.3246a719a338b2f3f27bb82694ffb48e.svg";
export { ForwardRef as ReactComponent };